import * as tslib_1 from "tslib";
import { FieldType } from '@ngx-formly/core';
var FormlyFieldAssignToComponent = /** @class */ (function (_super) {
    tslib_1.__extends(FormlyFieldAssignToComponent, _super);
    function FormlyFieldAssignToComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return FormlyFieldAssignToComponent;
}(FieldType));
export { FormlyFieldAssignToComponent };
